import React, { Component } from "react";
import IntlMessages from "../helpers/IntlMessages";
//import "./BookingApp.css";
//import Select from "react-select";

export default class PropertyPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.open_property_popup,
      isCheckedAvailability: this.props.isCheckedAvailability || false,
      pid:
        localStorage.getItem(this.props.property_state_store) !== undefined &&
          localStorage.getItem(this.props.property_state_store) !== null
          ? localStorage.getItem(this.props.property_state_store)
          : "",
    };

    if (!this.props.bookingApp.rooms) {
      this.props.bookingApp.rooms = 1;
      this.props.bookingApp.adults = 1;
      this.props.bookingApp.children = 0;
    }

    this.selectProperty = (elem) => {
      this.props.bookingApp.selectedPid = elem;
      this.props.setPropertyPopUp(false);
      this.forceUpdate();
      localStorage.setItem(this.props.bookingApp.lStore.PROPERTYID, elem.value);
      localStorage.setItem(
        this.props.bookingApp.lStore.PROPERTYNAME,
        elem.label
      );
      this.props.loadFormSetting(this.props.gid, elem.value);
      this.props.bookingApp.callbacks.getStore().dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/update",
          value: {
            pid: elem.value,
            pname: elem.label,
          },
        },
      });
      this.setState({ active: false });
      this.props.close_property_popup();
      this.props.GetServiceAvailable(this.props.property_state_store);
    };
    this.sendDates = this.sendDates.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  // componentDidUpdate = (prevProps, prevState, snapshot) => {
  //   if (
  //     this.props.room_app &&
  //     this.props.room_app.reinit &&
  //     this.state.active !== true
  //   ) {
  //     this.setState({ active: this.props.room_app.reinit });
  //     this.setState({ open: this.props.room_app.reinit });
  //   }
  // };

  //  FIXME:
  // This EventListener is to ensure that the pop up window closes when the user enters the input box at the bottom. But it will affect the input in the pop up window.
  //  FIXME:
  // componentDidMount = () => {
  //   window.addEventListener("input", this.close_pop.bind(this), false);
  // };

  toggle() {
    const { active } = this.state;
    this.setState({ active: !active });
    this.setState({ open: !active });
    this.props.setPropertyPopUp(false);
    this.props.close_pop();
    this.props.close_property_popup();
  }
  close_pop(event) {
    if (this.state.active) {
      this.setState({ active: false });
      this.setState({ open: false });
      this.props.setPropertyPopUp(false);
      this.props.close_pop();
      this.props.close_property_popup();
    }
  }

  sendDates() {
    var hotel = {};
    if (this.props.bookingApp.selectedPid) {
      hotel = this.state.properties.find(
        (property) => property.pid === this.props.bookingApp.selectedPid
      );
    }
    this.props.bookingApp.callbacks.getStore().dispatch({
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "webchat/booking-details",
        value: {
          hotel: hotel.name,
          dates: this.props.bookingApp.dates,
          rooms: this.props.bookingApp.rooms,
          adults: this.props.bookingApp.adults,
          kids: this.props.bookingApp.kids,
        },
      },
    });
    //this.close();
    this.close_pop();
  }

  setCheckAvailability = (isCheckedAvailability) => {
    this.setState({ isCheckedAvailability: isCheckedAvailability });
  };

  render() {
    var { room_app } = this.props;
    var { selectedPid } = this.props.bookingApp;
    var hotel = "";
    if (selectedPid) {
      hotel = this.props.bookingApp.properties.find(
        (property) => property.pid === selectedPid
      );
    }
    return (
      <div className="chat_box_popup_new">
        <div
          className={`switch_language_popup ${this.state.active ? "area" : "closepop"
            }`}
        >
          <div
            className={
              this.props.mobile == "true"
                ? `switch_language_popup_header chat_header_mobile`
                : `switch_language_popup_header`
            }
            style={{ backgroundColor: this.props.botSettings.colours.header }}
          >
            <div className="header_icon" onClick={this.toggle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l6.29,6.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"></path>
              </svg>
            </div>
            <div
              className="header_text"
              style={{ color: this.props.botSettings.colours.headerText }}
            >
              <IntlMessages id="switch.property" />
            </div>
          </div>
          <div className="switch_language_popup_body">
            <div
              className={`switch_language_popup_body popup_items ${this.props.mobile == "true"
                ? "popup_items_mobile"
                : "popup_items"
                }`}
            >
              {this.props.bookingApp.properties &&
                this.props.bookingApp.properties.map((elem, index) => (
                  <button
                    className="popupmenu"
                    onClick={() => this.selectProperty(elem)}
                    key={index}
                  >
                    <span className="text">{elem.label}</span>
                    {this.state.pid === elem.value ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        style={{ color: "#19af19" }}
                      >
                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"></path>
                      </svg>
                    ) : (
                      ""
                    )}
                  </button>
                ))}
            </div>
          </div>
        </div>
      </div>
      // <div className="chat_popup booking_popup" style={{ zIndex: 3 }}>
      //   <div
      //     className={`popup-slider ${
      //       this.state.active || (room_app && room_app.reinit)
      //         ? "slideIn"
      //         : "slideOut"
      //     }`}
      //     style={{ marginLeft: "auto", marginRight: "auto" }}
      //   >
      //     <div className="w-100">
      //       {this.props.bookingApp.properties && (
      //         <Select
      //           options={this.props.bookingApp.properties}
      //           onChange={this.selectProperty}
      //           value={this.props.bookingApp.selectedPid}
      //           placeholder="Select Property..."
      //           styles={customStyles}
      //         />
      //       )}
      //     </div>
      //   </div>
      //   {(room_app && room_app.details.length > 0) ||
      //   this.props.bookingApp.properties !== undefined ? (
      //     <div
      //       className="booking_close_divider"
      //       style={{
      //         backgroundColor: this.props.botSettings.colours.header
      //       }}
      //       onClick={this.toggle}
      //     >
      //       {this.state.active ? (
      //         <span className="glyphicon glyphicon-menu-up booking_close_divider_icon" />
      //       ) : (
      //         <span className="glyphicon glyphicon-menu-down booking_close_divider_icon" />
      //       )}
      //     </div>
      //   ) : null}
      // </div>
    );
  }
}
